import React, { useContext, useState, useEffect } from 'react';
import { View, Text, ScrollView, TouchableOpacity, Image } from 'react-native';
import { colors } from '../context/Colors';
import AppContext from '../context';
import Icon from 'react-native-vector-icons/Ionicons';
import { useColorScheme } from 'react-native-appearance';
import { useNavigation } from '@react-navigation/native';

export default function Progress() {
  const navigation = useNavigation();
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const { tour, setTour, setGameMenuHeight, dict } = useContext(AppContext);
  const [width, setWidth] = useState(200);

  useEffect(() => {
    tour.badgeAlbum = 0;
    setTour({ ...tour });
  }, []);

  const calcWidth = (containerWidth) => {
    if (containerWidth > 600) {
      setWidth(containerWidth / 2);
    } else {
      setWidth(containerWidth);
    }
  };

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10
      }}
      onLayout={(e) => {
        setGameMenuHeight(e.nativeEvent.layout.height);
        calcWidth(e.nativeEvent.layout.width);
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TouchableOpacity
          style={{ padding: 10, marginLeft: -10 }}
          onPress={() => navigation.goBack()}
        >
          <Icon name="chevron-back" color={colors[theme].text} size={22} />
        </TouchableOpacity>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 19,
            fontWeight: '600',
            flex: 1,
            textAlign: 'center'
          }}
        >
          {dict.photo_album}
        </Text>
        <View style={{ width: 34 }} />
      </View>
      <ScrollView>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
          }}
        >
          {tour.album.map((a, k) => (
            <TouchableOpacity
              key={k}
              onPress={() => navigation.navigate('AlbumView', k)}
            >
              <Image
                source={{ uri: a.url }}
                style={{
                  width: width / 2 - 15,
                  height: width / 2 - 15,
                  borderRadius: 10,
                  marginBottom: 10,
                  resizeMode: 'cover'
                }}
              />
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
    </View>
  );
}
